export const DEMO_TOKEN = 'demo-token-rcrastro';

const demoUser = {
  id: 'demo-user-rcrastro',
  name: 'Administrador RCrastro',
  email: 'admin@rcrastro.com.br',
  role: 'admin',
};

const vehiclesKey = 'rcrastro_demo_vehicles';
const alertsKey = 'rcrastro_demo_alerts';
const usersKey = 'rcrastro_demo_users';
const geofencesKey = 'rcrastro_demo_geofences';
const clientsKey = 'rcrastro_demo_clients';
const invoicesKey = 'rcrastro_demo_invoices';
const commandsKey = 'rcrastro_demo_commands';
const devicesKey = 'rcrastro_demo_devices';

const now = () => new Date().toISOString();

const defaultAlertSettings = {
  speed_limit: {
    enabled: false,
    threshold: 80,
    cooldown_minutes: 5,
    severity: 'high',
  },
  low_battery: {
    enabled: false,
    threshold: 20,
    cooldown_minutes: 60,
    severity: 'medium',
  },
  ignition_on: {
    enabled: false,
    cooldown_minutes: 2,
    severity: 'low',
  },
  ignition_off: {
    enabled: false,
    cooldown_minutes: 2,
    severity: 'low',
  },
  movement_started: {
    enabled: false,
    cooldown_minutes: 10,
    severity: 'medium',
  },
};

const defaultNotificationSettings = {
  email_enabled: false,
  notification_emails: '',
};

const mergeAlertSettings = (settings = {}) => ({
  ...Object.entries(defaultAlertSettings).reduce((result, [key, value]) => ({
    ...result,
    [key]: {
      ...value,
      ...(settings?.[key] || {}),
    },
  }), {}),
  email_enabled: Boolean(settings.email_enabled ?? defaultNotificationSettings.email_enabled),
  notification_emails: settings.notification_emails || defaultNotificationSettings.notification_emails,
});

const defaultVehicles = [
  {
    id: 'vehicle-001',
    name: 'Frota Centro',
    plate: 'RCR-2026',
    brand: 'Fiat',
    model: 'Strada',
    year: 2024,
    color: 'Branco',
    type: 'car',
    imei: '860000000000001',
    is_active: true,
    is_blocked: false,
    icon: 'car',
    positions: [
      {
        id: 'position-001',
        latitude: -23.55052,
        longitude: -46.63331,
        speed: 42,
        heading: 90,
        battery: 88,
        ignition: true,
        motion: true,
        address: 'Praca da Se, Sao Paulo - SP',
        device_time: now(),
      },
    ],
  },
  {
    id: 'vehicle-002',
    name: 'Van Entregas Norte',
    plate: 'LOG-4512',
    brand: 'Renault',
    model: 'Master',
    year: 2022,
    color: 'Prata',
    type: 'van',
    imei: '860000000000002',
    is_active: true,
    is_blocked: false,
    icon: 'van',
    positions: [
      {
        id: 'position-002',
        latitude: -23.51412,
        longitude: -46.62463,
        speed: 0,
        heading: 15,
        battery: 71,
        ignition: false,
        motion: false,
        address: 'Santana, Sao Paulo - SP',
        device_time: now(),
      },
    ],
  },
  {
    id: 'vehicle-003',
    name: 'Moto Suporte',
    plate: 'SUP-9090',
    brand: 'Honda',
    model: 'CG 160',
    year: 2023,
    color: 'Vermelha',
    type: 'motorcycle',
    imei: '860000000000003',
    is_active: false,
    is_blocked: false,
    icon: 'motorcycle',
    positions: [
      {
        id: 'position-003',
        latitude: -23.58742,
        longitude: -46.65763,
        speed: 0,
        heading: 220,
        battery: 18,
        ignition: false,
        motion: false,
        address: 'Vila Mariana, Sao Paulo - SP',
        device_time: now(),
      },
    ],
  },
];

const defaultDevices = [
  {
    id: 'device-001',
    user_id: demoUser.id,
    vehicle_id: 'vehicle-001',
    imei: '860000000000001',
    model: 'J16',
    brand: 'Concox',
    sim_card: '895500000000000001',
    carrier: 'Vivo',
    status: 'installed',
    supplier: 'Fornecedor RCR',
    purchase_value: 145,
    purchased_at: '2026-01-05',
    installed_at: '2026-01-10',
    last_seen_at: now(),
    firmware: '1.0.7',
    notes: 'Instalado na frota de demonstracao.',
    created_at: now(),
    vehicle: {
      id: 'vehicle-001',
      name: 'Frota Centro',
      plate: 'RCR-2026',
    },
  },
  {
    id: 'device-002',
    user_id: demoUser.id,
    vehicle_id: '',
    imei: '860000000000099',
    model: 'TK905',
    brand: 'Cobain',
    sim_card: '',
    carrier: '',
    status: 'stock',
    supplier: 'Estoque inicial',
    purchase_value: 110,
    purchased_at: '2026-03-01',
    installed_at: '',
    last_seen_at: '',
    firmware: '',
    notes: 'Disponivel para instalacao.',
    created_at: now(),
    vehicle: null,
  },
];

const defaultAlerts = [
  {
    id: 'alert-001',
    vehicle_id: 'vehicle-003',
    user_id: demoUser.id,
    type: 'low_battery',
    severity: 'high',
    title: 'Bateria baixa',
    message: 'O rastreador da Moto Suporte esta com bateria em 18%.',
    address: 'Vila Mariana, Sao Paulo - SP',
    is_read: false,
    created_at: now(),
    vehicle: {
      id: 'vehicle-003',
      name: 'Moto Suporte',
      plate: 'SUP-9090',
      icon: 'motorcycle',
    },
  },
  {
    id: 'alert-002',
    vehicle_id: 'vehicle-001',
    user_id: demoUser.id,
    type: 'ignition_on',
    severity: 'medium',
    title: 'Ignicao ligada',
    message: 'Frota Centro iniciou deslocamento ha poucos minutos.',
    address: 'Praca da Se, Sao Paulo - SP',
    is_read: false,
    created_at: now(),
    vehicle: {
      id: 'vehicle-001',
      name: 'Frota Centro',
      plate: 'RCR-2026',
      icon: 'car',
    },
  },
];

const defaultUsers = [
  demoUser,
  {
    id: 'demo-operator-rcrastro',
    name: 'Operador RCrastro',
    email: 'operador@rcrastro.com.br',
    phone: '(11) 90000-0000',
    cpf: '',
    role: 'operator',
    is_active: true,
    created_at: now(),
  },
];

const defaultGeofences = [
  {
    id: 'geofence-001',
    user_id: demoUser.id,
    name: 'Base Centro',
    description: 'Area de controle operacional',
    type: 'circle',
    coordinates: {
      latitude: -23.55052,
      longitude: -46.63331,
    },
    radius: 800,
    color: '#0ea5e9',
    is_active: true,
    alert_on_enter: true,
    alert_on_exit: true,
    created_at: now(),
  },
];

const defaultClients = [
  {
    id: 'client-001',
    user_id: demoUser.id,
    name: 'Transportes Centro Ltda',
    document: '12.345.678/0001-90',
    email: 'financeiro@transportescentro.com.br',
    phone: '(11) 4000-1000',
    address: 'Rua Boa Vista, 100',
    city: 'Sao Paulo',
    state: 'SP',
    status: 'active',
    plan_name: 'Frota Pro',
    monthly_value: 249.9,
    billing_day: 10,
    contract_start: '2026-01-01',
    contract_end: '',
    notes: 'Cliente demonstrativo com plano mensal ativo.',
    created_at: now(),
  },
  {
    id: 'client-002',
    user_id: demoUser.id,
    name: 'Logistica Norte ME',
    document: '98.765.432/0001-10',
    email: 'contato@logisticanorte.com.br',
    phone: '(11) 98888-7777',
    address: 'Avenida Cruzeiro, 45',
    city: 'Guarulhos',
    state: 'SP',
    status: 'overdue',
    plan_name: 'Essencial',
    monthly_value: 119.9,
    billing_day: 5,
    contract_start: '2026-02-15',
    contract_end: '',
    notes: 'Verificar regularizacao do pagamento.',
    created_at: now(),
  },
];

const defaultInvoices = [
  {
    id: 'invoice-001',
    user_id: demoUser.id,
    client_id: 'client-001',
    invoice_number: 'RCR-202605-001',
    description: 'Mensalidade Frota Pro',
    reference_month: '2026-05',
    amount: 249.9,
    status: 'open',
    due_date: '2026-05-10',
    paid_date: '',
    payment_method: '',
    notes: '',
    created_at: now(),
    client: {
      id: 'client-001',
      name: 'Transportes Centro Ltda',
      document: '12.345.678/0001-90',
      plan_name: 'Frota Pro',
    },
  },
  {
    id: 'invoice-002',
    user_id: demoUser.id,
    client_id: 'client-002',
    invoice_number: 'RCR-202605-002',
    description: 'Mensalidade Essencial',
    reference_month: '2026-05',
    amount: 119.9,
    status: 'overdue',
    due_date: '2026-05-05',
    paid_date: '',
    payment_method: '',
    notes: 'Aguardando retorno do cliente.',
    created_at: now(),
    client: {
      id: 'client-002',
      name: 'Logistica Norte ME',
      document: '98.765.432/0001-10',
      plan_name: 'Essencial',
    },
  },
];

const defaultCommands = [
  {
    id: 'command-001',
    user_id: demoUser.id,
    vehicle_id: 'vehicle-001',
    type: 'request_position',
    status: 'executed',
    command: 'REQUEST_POSITION',
    payload: null,
    response: 'Posicao enviada pelo rastreador',
    sent_at: now(),
    executed_at: now(),
    notes: '',
    created_at: now(),
    vehicle: {
      id: 'vehicle-001',
      name: 'Frota Centro',
      plate: 'RCR-2026',
      imei: '860000000000001',
      is_blocked: false,
    },
  },
  {
    id: 'command-002',
    user_id: demoUser.id,
    vehicle_id: 'vehicle-002',
    type: 'reboot',
    status: 'pending',
    command: 'REBOOT_DEVICE',
    payload: null,
    response: '',
    sent_at: '',
    executed_at: '',
    notes: 'Reinicio preventivo do rastreador',
    created_at: now(),
    vehicle: {
      id: 'vehicle-002',
      name: 'Van Entregas Norte',
      plate: 'LOG-4512',
      imei: '860000000000002',
      is_blocked: false,
    },
  },
];

const readJson = (key, fallback) => {
  const stored = localStorage.getItem(key);
  if (!stored) {
    localStorage.setItem(key, JSON.stringify(fallback));
    return fallback;
  }

  try {
    return JSON.parse(stored);
  } catch {
    localStorage.setItem(key, JSON.stringify(fallback));
    return fallback;
  }
};

const writeJson = (key, value) => {
  localStorage.setItem(key, JSON.stringify(value));
  return value;
};

const response = (data, extra = {}) => Promise.resolve({
  data: {
    success: true,
    data,
    ...extra,
  },
});

const createId = (prefix) => {
  if (window.crypto?.randomUUID) {
    return `${prefix}-${window.crypto.randomUUID()}`;
  }
  return `${prefix}-${Date.now()}`;
};

export const isDemoSession = () => localStorage.getItem('token') === DEMO_TOKEN;

export const mockApi = {
  login: () => response({ user: demoUser, token: DEMO_TOKEN }),

  updateProfile: (data) => {
    const currentUser = JSON.parse(localStorage.getItem('user')) || demoUser;
    const user = {
      ...currentUser,
      name: data.name || currentUser.name,
      phone: data.phone || currentUser.phone || '',
      cpf: data.cpf || currentUser.cpf || '',
    };

    localStorage.setItem('user', JSON.stringify(user));
    return response(user);
  },

  updatePassword: (data) => {
    if (!data.currentPassword || !data.newPassword) {
      return Promise.reject({
        response: {
          data: {
            message: 'Informe a senha atual e a nova senha',
          },
        },
      });
    }

    return response(null, { message: 'Senha alterada com sucesso' });
  },

  getUsers: () => {
    const users = readJson(usersKey, defaultUsers);
    return response(users, { count: users.length });
  },

  createUser: (data) => {
    const users = readJson(usersKey, defaultUsers);
    const user = {
      id: createId('user'),
      name: data.name,
      email: data.email,
      phone: data.phone || '',
      cpf: data.cpf || '',
      role: data.role || 'user',
      is_active: data.is_active !== false,
      created_at: now(),
    };

    writeJson(usersKey, [user, ...users]);
    return response(user, { message: 'Usuario criado com sucesso' });
  },

  updateUser: (id, data) => {
    const users = readJson(usersKey, defaultUsers);
    let updatedUser = null;
    const updatedUsers = users.map((user) => {
      if (user.id !== id) return user;

      updatedUser = {
        ...user,
        ...data,
        password: undefined,
      };
      return updatedUser;
    });

    writeJson(usersKey, updatedUsers);
    return response(updatedUser, { message: 'Usuario atualizado com sucesso' });
  },

  deleteUser: (id) => {
    const users = readJson(usersKey, defaultUsers);
    let updatedUser = null;
    const updatedUsers = users.map((user) => {
      if (user.id !== id) return user;

      updatedUser = {
        ...user,
        is_active: false,
      };
      return updatedUser;
    });

    writeJson(usersKey, updatedUsers);
    return response(updatedUser, { message: 'Usuario desativado com sucesso' });
  },

  getGeofences: () => {
    const geofences = readJson(geofencesKey, defaultGeofences);
    return response(geofences, { count: geofences.length });
  },

  createGeofence: (data) => {
    const geofences = readJson(geofencesKey, defaultGeofences);
    const geofence = {
      id: createId('geofence'),
      user_id: demoUser.id,
      name: data.name,
      description: data.description || '',
      type: 'circle',
      coordinates: data.coordinates,
      radius: Number(data.radius || 300),
      color: data.color || '#0ea5e9',
      is_active: data.is_active !== false,
      alert_on_enter: Boolean(data.alert_on_enter),
      alert_on_exit: Boolean(data.alert_on_exit),
      created_at: now(),
    };

    writeJson(geofencesKey, [geofence, ...geofences]);
    return response(geofence, { message: 'Cerca criada com sucesso' });
  },

  updateGeofence: (id, data) => {
    const geofences = readJson(geofencesKey, defaultGeofences);
    let updatedGeofence = null;
    const updatedGeofences = geofences.map((geofence) => {
      if (geofence.id !== id) return geofence;

      updatedGeofence = {
        ...geofence,
        ...data,
        radius: data.radius ? Number(data.radius) : geofence.radius,
        updated_at: now(),
      };
      return updatedGeofence;
    });

    writeJson(geofencesKey, updatedGeofences);
    return response(updatedGeofence, { message: 'Cerca atualizada com sucesso' });
  },

  deleteGeofence: (id) => {
    const geofences = readJson(geofencesKey, defaultGeofences).filter((geofence) => geofence.id !== id);
    writeJson(geofencesKey, geofences);
    return response(null, { message: 'Cerca removida com sucesso' });
  },

  getClients: () => {
    const clients = readJson(clientsKey, defaultClients);
    return response(clients, { count: clients.length });
  },

  createClient: (data) => {
    const clients = readJson(clientsKey, defaultClients);
    const client = {
      id: createId('client'),
      user_id: demoUser.id,
      name: data.name,
      document: data.document || '',
      email: data.email || '',
      phone: data.phone || '',
      address: data.address || '',
      city: data.city || '',
      state: data.state || '',
      status: data.status || 'active',
      plan_name: data.plan_name || '',
      monthly_value: Number(data.monthly_value || 0),
      billing_day: data.billing_day ? Number(data.billing_day) : null,
      contract_start: data.contract_start || '',
      contract_end: data.contract_end || '',
      notes: data.notes || '',
      created_at: now(),
    };

    writeJson(clientsKey, [client, ...clients]);
    return response(client, { message: 'Cliente criado com sucesso' });
  },

  updateClient: (id, data) => {
    const clients = readJson(clientsKey, defaultClients);
    let updatedClient = null;
    const updatedClients = clients.map((client) => {
      if (client.id !== id) return client;

      updatedClient = {
        ...client,
        ...data,
        monthly_value: Number(data.monthly_value || 0),
        billing_day: data.billing_day ? Number(data.billing_day) : null,
        updated_at: now(),
      };
      return updatedClient;
    });

    writeJson(clientsKey, updatedClients);
    return response(updatedClient, { message: 'Cliente atualizado com sucesso' });
  },

  deleteClient: (id) => {
    const clients = readJson(clientsKey, defaultClients).filter((client) => client.id !== id);
    writeJson(clientsKey, clients);
    return response(null, { message: 'Cliente removido com sucesso' });
  },

  getInvoices: () => {
    const clients = readJson(clientsKey, defaultClients);
    const invoices = readJson(invoicesKey, defaultInvoices).map((invoice) => ({
      ...invoice,
      client: clients.find((client) => client.id === invoice.client_id) || invoice.client,
    }));
    return response(invoices, { count: invoices.length });
  },

  createInvoice: (data) => {
    const clients = readJson(clientsKey, defaultClients);
    const invoices = readJson(invoicesKey, defaultInvoices);
    const client = clients.find((item) => item.id === data.client_id);
    const invoice = {
      id: createId('invoice'),
      user_id: demoUser.id,
      client_id: data.client_id,
      invoice_number: data.invoice_number || `RCR-${Date.now()}`,
      description: data.description,
      reference_month: data.reference_month || '',
      amount: Number(data.amount || 0),
      status: data.status || 'open',
      due_date: data.due_date,
      paid_date: data.status === 'paid' ? (data.paid_date || now().slice(0, 10)) : (data.paid_date || ''),
      payment_method: data.payment_method || '',
      notes: data.notes || '',
      created_at: now(),
      client,
    };

    writeJson(invoicesKey, [invoice, ...invoices]);
    return response(invoice, { message: 'Cobranca criada com sucesso' });
  },

  updateInvoice: (id, data) => {
    const clients = readJson(clientsKey, defaultClients);
    const invoices = readJson(invoicesKey, defaultInvoices);
    let updatedInvoice = null;
    const updatedInvoices = invoices.map((invoice) => {
      if (invoice.id !== id) return invoice;
      const client = clients.find((item) => item.id === data.client_id) || invoice.client;

      updatedInvoice = {
        ...invoice,
        ...data,
        amount: Number(data.amount || 0),
        paid_date: data.status === 'paid' ? (data.paid_date || now().slice(0, 10)) : (data.paid_date || ''),
        client,
        updated_at: now(),
      };
      return updatedInvoice;
    });

    writeJson(invoicesKey, updatedInvoices);
    return response(updatedInvoice, { message: 'Cobranca atualizada com sucesso' });
  },

  markInvoicePaid: (id, data = {}) => {
    const invoices = readJson(invoicesKey, defaultInvoices);
    let updatedInvoice = null;
    const updatedInvoices = invoices.map((invoice) => {
      if (invoice.id !== id) return invoice;

      updatedInvoice = {
        ...invoice,
        status: 'paid',
        paid_date: data.paid_date || now().slice(0, 10),
        payment_method: data.payment_method || invoice.payment_method || 'Manual',
        updated_at: now(),
      };
      return updatedInvoice;
    });

    writeJson(invoicesKey, updatedInvoices);
    return response(updatedInvoice, { message: 'Cobranca marcada como paga' });
  },

  deleteInvoice: (id) => {
    const invoices = readJson(invoicesKey, defaultInvoices).filter((invoice) => invoice.id !== id);
    writeJson(invoicesKey, invoices);
    return response(null, { message: 'Cobranca removida com sucesso' });
  },

  getCommands: () => {
    const vehicles = readJson(vehiclesKey, defaultVehicles);
    const commands = readJson(commandsKey, defaultCommands).map((command) => ({
      ...command,
      vehicle: vehicles.find((vehicle) => vehicle.id === command.vehicle_id) || command.vehicle,
    }));
    return response(commands, { count: commands.length });
  },

  createCommand: (data) => {
    const vehicles = readJson(vehiclesKey, defaultVehicles);
    const commands = readJson(commandsKey, defaultCommands);
    const vehicle = vehicles.find((item) => item.id === data.vehicle_id);
    const commandMap = {
      block: 'BLOCK_ENGINE',
      unblock: 'UNBLOCK_ENGINE',
      request_position: 'REQUEST_POSITION',
      reboot: 'REBOOT_DEVICE',
      custom: data.command || 'CUSTOM',
    };
    const status = data.status || 'pending';
    const command = {
      id: createId('command'),
      user_id: demoUser.id,
      vehicle_id: data.vehicle_id,
      type: data.type || 'request_position',
      status,
      command: commandMap[data.type] || commandMap.request_position,
      payload: data.payload || null,
      response: '',
      sent_at: status === 'sent' || status === 'executed' ? now() : '',
      executed_at: status === 'executed' ? now() : '',
      notes: data.notes || '',
      created_at: now(),
      vehicle,
    };

    writeJson(commandsKey, [command, ...commands]);
    return response(command, { message: 'Comando registrado com sucesso' });
  },

  updateCommandStatus: (id, data) => {
    const commands = readJson(commandsKey, defaultCommands);
    let updatedCommand = null;
    const updatedCommands = commands.map((command) => {
      if (command.id !== id) return command;

      updatedCommand = {
        ...command,
        status: data.status,
        response: data.response || command.response || '',
        notes: data.notes || command.notes || '',
        sent_at: data.status === 'sent' || data.status === 'executed' ? (command.sent_at || now()) : command.sent_at,
        executed_at: data.status === 'executed' ? now() : command.executed_at,
        updated_at: now(),
      };
      return updatedCommand;
    });

    writeJson(commandsKey, updatedCommands);
    return response(updatedCommand, { message: 'Status do comando atualizado' });
  },

  deleteCommand: (id) => {
    const commands = readJson(commandsKey, defaultCommands).filter((command) => command.id !== id);
    writeJson(commandsKey, commands);
    return response(null, { message: 'Comando removido com sucesso' });
  },

  getDevices: () => {
    const vehicles = readJson(vehiclesKey, defaultVehicles);
    const devices = readJson(devicesKey, defaultDevices).map((device) => ({
      ...device,
      vehicle: vehicles.find((vehicle) => vehicle.id === device.vehicle_id) || null,
    }));
    return response(devices, { count: devices.length });
  },

  createDevice: (data) => {
    const vehicles = readJson(vehiclesKey, defaultVehicles);
    const devices = readJson(devicesKey, defaultDevices);
    const vehicle = vehicles.find((item) => item.id === data.vehicle_id) || null;
    const device = {
      id: createId('device'),
      user_id: demoUser.id,
      vehicle_id: data.vehicle_id || '',
      imei: data.imei,
      model: data.model || '',
      brand: data.brand || '',
      sim_card: data.sim_card || '',
      carrier: data.carrier || '',
      status: data.status || (data.vehicle_id ? 'installed' : 'stock'),
      supplier: data.supplier || '',
      purchase_value: Number(data.purchase_value || 0),
      purchased_at: data.purchased_at || '',
      installed_at: data.installed_at || '',
      last_seen_at: data.last_seen_at || '',
      firmware: data.firmware || '',
      notes: data.notes || '',
      created_at: now(),
      vehicle,
    };

    writeJson(devicesKey, [device, ...devices]);
    return response(device, { message: 'Rastreador criado com sucesso' });
  },

  updateDevice: (id, data) => {
    const vehicles = readJson(vehiclesKey, defaultVehicles);
    const devices = readJson(devicesKey, defaultDevices);
    let updatedDevice = null;
    const updatedDevices = devices.map((device) => {
      if (device.id !== id) return device;
      const vehicle = vehicles.find((item) => item.id === data.vehicle_id) || null;

      updatedDevice = {
        ...device,
        ...data,
        vehicle_id: data.vehicle_id || '',
        purchase_value: Number(data.purchase_value || 0),
        vehicle,
        updated_at: now(),
      };
      return updatedDevice;
    });

    writeJson(devicesKey, updatedDevices);
    return response(updatedDevice, { message: 'Rastreador atualizado com sucesso' });
  },

  deleteDevice: (id) => {
    const devices = readJson(devicesKey, defaultDevices).filter((device) => device.id !== id);
    writeJson(devicesKey, devices);
    return response(null, { message: 'Rastreador removido com sucesso' });
  },

  getVehicles: () => {
    const vehicles = readJson(vehiclesKey, defaultVehicles);
    return response(vehicles, { count: vehicles.length });
  },

  createVehicle: (data) => {
    const vehicles = readJson(vehiclesKey, defaultVehicles);
    const vehicle = {
      id: createId('vehicle'),
      name: data.name,
      plate: data.plate?.toUpperCase(),
      brand: data.brand || '',
      model: data.model || '',
      year: data.year ? Number(data.year) : null,
      color: data.color || '',
      type: data.type || 'car',
      imei: data.imei || '',
      is_active: true,
      is_blocked: false,
      icon: data.type || 'car',
      positions: [],
      created_at: now(),
    };

    writeJson(vehiclesKey, [vehicle, ...vehicles]);
    return response(vehicle);
  },

  updateVehicle: (id, data) => {
    const vehicles = readJson(vehiclesKey, defaultVehicles);
    let updatedVehicle = null;
    const updatedVehicles = vehicles.map((vehicle) => {
      if (vehicle.id !== id) return vehicle;

      updatedVehicle = {
        ...vehicle,
        ...data,
        plate: data.plate ? data.plate.toUpperCase() : vehicle.plate,
        year: data.year ? Number(data.year) : null,
      };
      return updatedVehicle;
    });

    writeJson(vehiclesKey, updatedVehicles);
    return response(updatedVehicle);
  },

  deleteVehicle: (id) => {
    const vehicles = readJson(vehiclesKey, defaultVehicles).filter((vehicle) => vehicle.id !== id);
    writeJson(vehiclesKey, vehicles);
    return response(null, { message: 'Veiculo removido com sucesso' });
  },

  toggleVehicleBlock: (id) => {
    const vehicles = readJson(vehiclesKey, defaultVehicles);
    let updatedVehicle = null;
    const updatedVehicles = vehicles.map((vehicle) => {
      if (vehicle.id !== id) return vehicle;
      updatedVehicle = { ...vehicle, is_blocked: !vehicle.is_blocked };
      return updatedVehicle;
    });

    writeJson(vehiclesKey, updatedVehicles);

    if (updatedVehicle) {
      const alerts = readJson(alertsKey, defaultAlerts);
      const alert = {
        id: createId('alert'),
        vehicle_id: updatedVehicle.id,
        user_id: demoUser.id,
        type: 'custom',
        severity: 'high',
        title: updatedVehicle.is_blocked ? 'Veiculo bloqueado' : 'Veiculo desbloqueado',
        message: `${updatedVehicle.name} foi ${updatedVehicle.is_blocked ? 'bloqueado' : 'desbloqueado'} remotamente.`,
        is_read: false,
        created_at: now(),
        vehicle: {
          id: updatedVehicle.id,
          name: updatedVehicle.name,
          plate: updatedVehicle.plate,
          icon: updatedVehicle.icon,
        },
      };
      writeJson(alertsKey, [alert, ...alerts]);
    }

    return response(updatedVehicle, {
      message: updatedVehicle?.is_blocked ? 'Veiculo bloqueado com sucesso' : 'Veiculo desbloqueado com sucesso',
    });
  },

  getAlerts: (params = {}) => {
    const limit = Number(params?.limit || 50);
    const alerts = readJson(alertsKey, defaultAlerts).slice(0, limit);
    return response(alerts, { count: alerts.length });
  },

  getAlertSettings: () => {
    const vehicles = readJson(vehiclesKey, defaultVehicles).map((vehicle) => ({
      id: vehicle.id,
      name: vehicle.name,
      plate: vehicle.plate,
      imei: vehicle.imei,
      type: vehicle.type,
      icon: vehicle.icon,
      alert_settings: mergeAlertSettings(vehicle.alert_settings),
    }));

    return response(vehicles, { count: vehicles.length });
  },

  updateAlertSettings: (vehicleId, data = {}) => {
    const vehicles = readJson(vehiclesKey, defaultVehicles);
    const nextSettings = mergeAlertSettings(data.alert_settings || data);
    const updatedVehicles = vehicles.map((vehicle) => (
      vehicle.id === vehicleId ? { ...vehicle, alert_settings: nextSettings } : vehicle
    ));
    const vehicle = updatedVehicles.find((item) => item.id === vehicleId);

    writeJson(vehiclesKey, updatedVehicles);

    return response({
      id: vehicle?.id,
      name: vehicle?.name,
      plate: vehicle?.plate,
      imei: vehicle?.imei,
      type: vehicle?.type,
      icon: vehicle?.icon,
      alert_settings: nextSettings,
    }, { message: 'Configuracoes de alertas salvas' });
  },

  markAlertAsRead: (id) => {
    const alerts = readJson(alertsKey, defaultAlerts);
    const updatedAlerts = alerts.map((alert) => (
      alert.id === id ? { ...alert, is_read: true, read_at: now() } : alert
    ));
    const alert = updatedAlerts.find((item) => item.id === id);
    writeJson(alertsKey, updatedAlerts);
    return response(alert);
  },

  markAllAlertsAsRead: () => {
    const alerts = readJson(alertsKey, defaultAlerts);
    writeJson(alertsKey, alerts.map((alert) => ({ ...alert, is_read: true, read_at: now() })));
    return response(null, { message: 'Todos os alertas foram marcados como lidos' });
  },

  deleteAlert: (id) => {
    const alerts = readJson(alertsKey, defaultAlerts).filter((alert) => alert.id !== id);
    writeJson(alertsKey, alerts);
    return response(null, { message: 'Alerta removido com sucesso' });
  },

  getUnreadCount: () => {
    const alerts = readJson(alertsKey, defaultAlerts);
    return response({ count: alerts.filter((alert) => !alert.is_read).length });
  },

  getPositions: (vehicleId) => {
    const vehicle = readJson(vehiclesKey, defaultVehicles).find((item) => item.id === vehicleId);
    return response(vehicle?.positions || [], { count: vehicle?.positions?.length || 0 });
  },

  getRoute: (vehicleId) => {
    const vehicle = readJson(vehiclesKey, defaultVehicles).find((item) => item.id === vehicleId);
    const basePosition = vehicle?.positions?.[0];
    const positions = basePosition ? Array.from({ length: 8 }, (_, index) => ({
      ...basePosition,
      id: `route-${vehicleId}-${index}`,
      latitude: Number(basePosition.latitude) + (index * 0.003),
      longitude: Number(basePosition.longitude) + (index * 0.002),
      speed: Math.max(0, Number(basePosition.speed || 0) - index * 3),
      device_time: new Date(Date.now() - index * 1000 * 60 * 18).toISOString(),
      ignition: index < 6,
    })).reverse() : [];

    const speeds = positions.map((position) => Number(position.speed || 0));

    return response({
      positions,
      stats: {
        totalPoints: positions.length,
        maxSpeed: speeds.length ? Math.max(...speeds) : 0,
        avgSpeed: speeds.length ? speeds.reduce((sum, speed) => sum + speed, 0) / speeds.length : 0,
      },
    });
  },

  simulatePosition: (data) => {
    const vehicles = readJson(vehiclesKey, defaultVehicles);
    let updatedVehicle = null;
    const position = {
      id: createId('position'),
      latitude: Number(data.latitude),
      longitude: Number(data.longitude),
      speed: Number(data.speed || 0),
      heading: data.heading ? Number(data.heading) : null,
      battery: data.battery ? Number(data.battery) : null,
      ignition: Boolean(data.ignition),
      motion: Boolean(data.motion),
      address: data.address || 'Posição simulada pelo painel',
      device_time: data.device_time || now(),
    };

    const updatedVehicles = vehicles.map((vehicle) => {
      const matches = data.vehicle_id ? vehicle.id === data.vehicle_id : vehicle.imei === data.imei;
      if (!matches) return vehicle;

      updatedVehicle = {
        ...vehicle,
        positions: [position],
        last_update: now(),
      };
      return updatedVehicle;
    });

    writeJson(vehiclesKey, updatedVehicles);

    return response({
      position,
      vehicle: updatedVehicle,
    }, { message: 'Posição simulada com sucesso' });
  },
};
